import { Component, OnInit, Input } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { FormControl, FormGroup } from '@angular/forms';
import { Ws10FormElementBlock } from '@vfde-fe/ngx-lib/brix/ws10-form-element-block';
import { TranslateService } from '@ngx-translate/core';
import { FORM_FIELD_TYPE, INPUT_TYPE } from '../../defines/defines';

/** TextInputBlockComponent */
@Component({
  selector: 'app-text-input-block',
  templateUrl: './text-input-block.component.html',
})
export class TextInputBlockComponent implements OnInit {
  /** formField */
  @Input() public formField: FormField;

  /** form */
  @Input() public form: FormGroup;

  /** formElementBlockConfig */
  public formElementBlockConfig: Ws10FormElementBlock;

  /** formControlName */
  public formControlName: string;

  /** optional field label  */
  public optional = this.ts.instant(
    'FromCenterModule.formRendering.optionalField.std-headline',
  );

  /** inputType */
  public inputType: INPUT_TYPE;

  /** constructor
   * @param ts:TranslateService
   */
  public constructor (public ts: TranslateService) {}

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.setTextInputType(this.formField.type);
      this.configureComponent(this.formField);
    }
  }

  /** setTextInputType
   * @method setTextInputType
   * @param {string} type
   */
  public setTextInputType (type: string) {
    switch (type) {
      case FORM_FIELD_TYPE.TEXT_INPUT:
        this.inputType = INPUT_TYPE.TEXT;
        break;
      case FORM_FIELD_TYPE.EMAIL:
        this.inputType = INPUT_TYPE.EMAIL;
        break;
      case FORM_FIELD_TYPE.DATE:
        this.inputType = INPUT_TYPE.DATE;
        break;
      case FORM_FIELD_TYPE.NUMBER:
        this.inputType = INPUT_TYPE.NUMBER;
        break;
      case FORM_FIELD_TYPE.TIME:
        this.inputType = INPUT_TYPE.DATE;
        break;
    }
  }
  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
  public configureComponent (data: FormField) {
    if (data && data.name && data.label && this.inputType) {
      const blockId = `block-id-${data.id}`;
      const blockAutId = `block-aut-id-${data.id}`;
      const fieldId = `field-id-${data.id}`;
      const fieldAutId = `field-aut-id-${data.id}`;
      const labelId = `label-id-${data.id}`;
      this.formElementBlockConfig = {
        id: blockId,
        automation_id: blockAutId,
        labelConfig: {
          id: labelId,
          txtValue: data.required
            ? data.label + '*'
            : data.label  + ' ' + this.optional,
          for: fieldId,
        },
        inputConfig: {
          textInput: {
            id: fieldId,
            automation_id: fieldAutId,
            type: this.inputType,
            name: data.name,
            isRequired: data.required,
            placeholder: data.placeholder,
            patternValue: this.inputType !== INPUT_TYPE.DATE ? data.constraints : null,
            maxLength: this.inputType === INPUT_TYPE.NUMBER ? data.maxLength : null,
            minLength: this.inputType === INPUT_TYPE.NUMBER ? data.minLength : null,
          },
        },
        helperText: data.hint,
        errorMessage: data.errorText,
      };
      this.formControlName = data.name;
      this.form.addControl(data.name, new FormControl(data.value));
    }
  }
}
